<template>
    <div class="manageContainer">
        <div class="property-selector" v-if="manageContent == 'main'">
            <el-select
                v-model="selectProp"
                default-first-option
                filterable
                value-key="name"
                :placeholder="$t('property.selectProperty')"
            >
                <el-option
                    v-for="(item, index) in portfolioResp.properties"
                    :key="index"
                    :label="item.name"
                    :value="item"
                >
                    <img class="property-flag" :src="item.country_flag_url" alt />
                    <span class="property-name">{{ item.name }}</span>
                </el-option>
            </el-select>
            <el-button
                type="primary"
                @click="linkToPID"
                class="hidden-sm-and-down"
            >{{$t('manage.ViewPropertyDetails')}}</el-button>
        </div>

        <section class="manage-content" v-if="hasManage">
            <el-row :gutter="20" v-if="manageContent == 'main'">
                <el-col :xs="24" :md="15">
                    <div class="manage-content-l">
                        <div class="manage-table action-table">
                            <h2>{{$t('manage.MyRequiredActions')}}</h2>
                            <el-table
                                :data="actions"
                                style="width: 100%"
                                header-row-class-name="table_header_style"
                                v-if="actions.length != 0"
                            >
                                <div v-if="innerW <= 414">
                                    <el-table-column width="120" :label="$t('manage.Status')">
                                        <template slot-scope="scope">
                                            <a
                                                @click="goToDetail(scope.$index, scope.row)"
                                                class="status"
                                                :class="scope.row.status"
                                            >{{ translateStatus(scope.row.status)}}</a>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('manage.Task')" width="180">
                                        <template slot-scope="scope">
                                            <p
                                                class="task"
                                                :class="scope.row.icon"
                                                :title="scope.row.name"
                                            >
                                                <a
                                                    @click="goToDetail(scope.$index, scope.row)"
                                                >{{ scope.row.name }}</a>
                                                <a
                                                    @click="goToDetail(scope.$index, scope.row)"
                                                    class="xs-link"
                                                >
                                                    <span>{{ scope.row.due_date }}</span>
                                                </a>
                                            </p>
                                        </template>
                                    </el-table-column>
                                </div>
                                <div v-else>
                                    <el-table-column width="120" :label="$t('manage.Status')">
                                        <template slot-scope="scope">
                                            <a
                                                @click="goToDetail(scope.$index, scope.row)"
                                                class="status"
                                                :class="scope.row.status"
                                            >{{ translateStatus(scope.row.status)}}</a>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('manage.Task')" width="180">
                                        <template slot-scope="scope">
                                            <p
                                                class="task"
                                                :class="scope.row.icon"
                                                :title="scope.row.name"
                                            >
                                                <a
                                                    @click="goToDetail(scope.$index, scope.row)"
                                                >{{ scope.row.name }}</a>
                                            </p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('manage.DueDate')" width="150">
                                        <template slot-scope="scope">
                                            <div class="dueDate">
                                                <a @click="goToDetail(scope.$index, scope.row)">
                                                    <span>{{ scope.row.due_date }}</span>
                                                </a>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </div>
                            </el-table>
                            <div v-else class="table_noResult">
                                <h4>{{$t('manage.todoList')}}</h4>
                                <!-- <p>If you've any completed tasks, it will be reflected here.</p> -->
                            </div>
                        </div>
                        <div class="manage-table complete-table">
                            <h2>{{$t('manage.COMPLETED')}}</h2>
                            <el-table
                                :data="updates"
                                style="width: 100%"
                                header-row-class-name="table_header_style"
                                v-if="updates.length != 0"
                            >
                                <div v-if="innerW <= 414">
                                    <el-table-column label width="120">
                                        <template slot-scope="scope">
                                            <a
                                                @click="goToDetail(scope.$index, scope.row)"
                                                class="status completed"
                                                v-if="scope.row.status == 'COMPLETED'"
                                            >{{$t('manage.Completed')}}</a>
                                            <a
                                                @click="goToDetail(scope.$index, scope.row)"
                                                class="status"
                                                v-else-if="scope.row.status == 'UPDATE'"
                                            >{{$t('manage.Update')}}</a>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('manage.Task')" width="180">
                                        <template slot-scope="scope">
                                            <p
                                                class="task"
                                                :class="scope.row.icon"
                                                :title="scope.row.name"
                                            >
                                                <a
                                                    @click="goToDetail(scope.$index, scope.row)"
                                                >{{ scope.row.name }}</a>
                                                <a
                                                    @click="goToDetail(scope.$index, scope.row)"
                                                    class="xs-link"
                                                >
                                                    <span>{{ scope.row.due_date }}</span>
                                                </a>
                                            </p>
                                        </template>
                                    </el-table-column>
                                </div>
                                <div v-else>
                                    <el-table-column label width="120">
                                        <template slot-scope="scope">
                                            <a
                                                @click="goToDetail(scope.$index, scope.row)"
                                                class="status completed"
                                                v-if="scope.row.status == 'COMPLETED'"
                                            >{{$t('manage.Completed')}}</a>
                                            <a
                                                @click="goToDetail(scope.$index, scope.row)"
                                                class="status"
                                                v-else-if="scope.row.status == 'UPDATE'"
                                            >{{$t('manage.Update')}}</a>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('manage.Task')" width="180">
                                        <template slot-scope="scope">
                                            <p
                                                class="task"
                                                :class="scope.row.icon"
                                                :title="scope.row.name"
                                            >
                                                <a
                                                    @click="goToDetail(scope.$index, scope.row)"
                                                >{{ scope.row.name }}</a>
                                            </p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('manage.DueDate')" width="150">
                                        <template slot-scope="scope">
                                            <div class="dueDate">
                                                <span>
                                                    <a
                                                        @click="goToDetail(scope.$index, scope.row)"
                                                    >{{ scope.row.due_date }}</a>
                                                </span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </div>
                            </el-table>
                            <div v-else class="table_noResult">
                                <h4>{{$t('manage.CompletedTask')}}</h4>
                                <p>{{$t('manage.receiveList')}}</p>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :md="9">
                    <div class="manage-content-r">
                        <div class="manage-table milestones">
                            <h2>{{$t('manage.Milestones')}}</h2>

                            <el-radio-group
                                v-model="milestones"
                                size="small"
                                :text-color="'#fff'"
                                :fill="'#3b6bbf'"
                                @change="chaneTimelineContent"
                            >
                                <el-radio-button label="PURCHASE_PROCESS">{{$t('manage.Purchase')}}</el-radio-button>
                                <el-radio-button label="MORTGAGE">{{$t('manage.Mortgage')}}</el-radio-button>
                                <el-radio-button label="RENT">{{$t('manage.Rental')}}</el-radio-button>
                            </el-radio-group>

                            <el-timeline v-if="timelines_content">
                                <el-timeline-item
                                    v-for="(item, index) in timelines_content"
                                    :key="index"
                                    :class="item.status"
                                    :icon="item.status == 'COMPLETED' || 'UPDATE' ? 'el-icon-circle-check' : ''"
                                >
                                    <el-card class="timeline_card">
                                        <div @click="goToDetail('',item)" class="card-link">
                                            <h3
                                                class="card-title"
                                                :class="[item.status, {document: item.has_documents}]"
                                            >{{item.name}}</h3>
                                            <p class="card-date">{{item.due_date}}</p>
                                        </div>
                                        <el-button
                                            class="card-btn"
                                            :class="item.status"
                                            type="primary"
                                            @click="goToDetail('',item)"
                                            v-if="item.status == 'TODO'"
                                        >{{$t('manage.ActionRequired')}}</el-button>

                                        <el-button
                                            class="card-btn"
                                            :class="item.status"
                                            type="primary"
                                            @click="goToDetail('',item)"
                                            v-if="item.status == 'PENDING'"
                                        >{{$t('manage.Pending')}}</el-button>

                                        <el-button
                                            class="card-btn"
                                            :class="item.status"
                                            type="primary"
                                            @click="goToDetail('',item)"
                                            v-if="item.status == 'ERROR'"
                                        >{{$t('manage.ErrorMilestone')}}</el-button>

                                        <el-button
                                            class="card-btn"
                                            :class="item.status"
                                            type="primary"
                                            @click="goToDetail('',item)"
                                            v-if="item.status == 'OVERDUE'"
                                        >{{$t('manage.OverdueMilestone')}}</el-button>
                                    </el-card>
                                </el-timeline-item>
                            </el-timeline>
                            <div v-else>
                                <div class="no-result">
                                    <h3>{{timelines_content_empty[milestones].title}}</h3>
                                    <p>{{timelines_content_empty[milestones].desc}}</p>
                                    <a
                                        class="btn solid-btn"
                                        target="_blank"
                                        href="https://hs.propertypassbook.com/meetings/passbookpremier/30-minute-global-portfolio-strategy-discussion"
                                    >{{$t('manage.BookaConsultation')}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>

            <manageDetails
                :selectProp="selectProp"
                :requestParams="requestParams"
                :requestHeaders="requestHeaders"
                :eventId="eventId"
                @goToPage="goToPage"
                v-if="manageContent == 'detail'"
            />
        </section>

        <section class="manage-content-empty" v-else-if="!hasManage">
            <h1>{{$t('manage.OptimizeProperty')}}</h1>
            <p class="manage-desc">{{$t('manage.simplifyRentalsMortgages')}}</p>
            <a
                class="btn solid-btn"
                target="_blank"
                href="https://hs.propertypassbook.com/meetings/passbookpremier/30-minute-global-portfolio-strategy-discussion"
            >{{$t('manage.BookaConsultation')}}</a>

            <ul class="empty-list">
                <li>
                    <span class="icon-empty icon-income"></span>
                    <p>{{$t('manage.MaximizeRentalIncome')}}</p>
                    <span class="empty-img empty-income"></span>
                    <a
                        target="_blank"
                        href="/rental-management-services/"
                    >{{$t('manage.LearnMore')}}</a>
                </li>
                <li>
                    <span class="icon-empty icon-returns"></span>
                    <p>{{$t('manage.IncreaseYourReturns')}}</p>
                    <span class="empty-img empty-returns"></span>
                    <a
                        target="_blank"
                        href="/optimize-your-property-portfolio/"
                    >{{$t('manage.LearnMore')}}</a>
                </li>
                <li>
                    <span class="icon-empty icon-cost"></span>
                    <p>{{$t('manage.LowerFinancingCosts')}}</p>
                    <span class="empty-img empty-cost"></span>
                    <a
                        target="_blank"
                        href="/optimize-your-property-portfolio/"
                    >{{$t('manage.LearnMore')}}</a>
                </li>
            </ul>
        </section>
    </div>
</template>
<script>
import { Message } from "element-ui";
import { Loading } from "element-ui";
import manageDetails from "@/components/account/manageDetails.vue";
let loading;

export default {
    name: "manageContainer",
    props: [
        "switchContent",
        "requestParams",
        "requestHeaders",
        "propertySelector",
        "portfolioResp"
    ],
    data() {
        const $t = this.$t.bind(this);
        return {
            innerW: window.innerWidth,
            hasManage: false,
            manageContent: "main",
            eventId: "",
            selectProp: {},
            property_list: [],
            updates: [],
            actions: [],
            milestones: "PURCHASE_PROCESS",
            timelines: {
                MORTGAGE: [],
                RENT: [],
                PURCHASE_PROCESS: []
            },
            timelines_content: [],
            timelines_content_empty: {
                MORTGAGE: {
                    title: this.$t("manage.MORTGAGE_title"),
                    desc: this.$t("manage.MORTGAGE_desc"),
                    bookConsultation: this.$t("property.BookaConsultation")
                },
                RENT: {
                    title: this.$t("manage.RENT_title"),
                    desc: this.$t("manage.RENT_desc"),
                    bookConsultation: this.$t("property.BookaConsultation")
                },
                PURCHASE_PROCESS: {
                    title: this.$t("manage.PURCHASE_PROCESS_title"),
                    desc: this.$t("manage.PURCHASE_PROCESS_desc"),
                    bookConsultation: this.$t("property.BookaConsultation")
                }
            },

            getPropUrl: "",
            getEventUrl: ""
        };
    },

    beforeMount() {
        this.initialData();
    },

    methods: {
        initialData() {
            this.loading();
            this.getPropUrl = `${this.requestParams.ppbApi}api/passbook/property/`;
            this.getEventUrl = `${this.requestParams.ppbApi}api/passbook/event/`;
            this.$http.get(this.getPropUrl, this.requestHeaders).then(resp => {
                this.property_list = resp.data.property_list;
                if (!this.propertySelector.hasOwnProperty("id")) {
                    this.selectProp = this.property_list[0];
                    this.timelines = this.property_list[0].timelines;
                } else {
                    this.setFirstProp();
                    this.matchProp();

                    this.chaneTimelineContent();
                }
                this.$emit("loaded", true);
                loading.close();
            });
        },

        matchProp() {
            let result = this.property_list.filter(
                it => it.id == this.propertySelector.id
            )[0];
            if (result != undefined) {
                this.selectProp = result;
            }
        },

        setFirstProp() {
            if (!this.selectProp.actions) {
                this.selectProp = this.portfolioResp.properties[0];
            }
        },

        goToPage(data) {
            this.manageContent = data;
            this.initialData();
        },

        linkToPID() {
            this.$emit("linkToPID", this.selectProp);
        },

        chaneTimelineContent() {
            this.timelines_content = this.timelines[this.milestones];
        },

        goToDetail(index, row) {
            this.manageContent = "detail";
            this.eventId = row.id;
        },

        translateStatus(val) {
            if (val == "PENDING") {
                return this.$t("manage.Pending");
            } else if (val == "FURTURE") {
                return this.$t("manage.Future");
            } else if (val == "TODO") {
                return;
            } else if (val == "OVERDUE") {
                return this.$t("manage.OverDue");
            } else if (val == "ERROR") {
                return this.$t("manage.Error");
            } else if (val == "COMPLETED") {
                return this.$t("manage.Completed");
            } else if (val == "UPDATE") {
                return this.$t("manage.Update");
            } else if (val == "FUTURE_UPDATE") {
                return this.$t("manage.Future_update");
            }
        },

        loading() {
            loading = this.$loading({
                lock: true,
                target: ".manageContainer",
                text: this.$t("searchResultPage.loading"),
                color: "#3b6bbf",
                background: "rgba(255, 255, 255, 0.8)"
            });
        },

        triggerMessage(type, options) {
            options.duration = 6000;
            return Message[type](options);
        }
    },

    filters: {
        formatStatus(val) {
            return val.toLowerCase().replace(/_/g, " ");
        }
    },

    watch: {
        selectProp: {
            handler(newVal, oldVal) {
                if (!newVal) return;
                let result = this.property_list.filter(
                    it => it.id == newVal.id
                )[0];

                if (result) {
                    this.hasManage = true;
                    this.actions = result.actions;
                    this.updates = result.updates;
                    this.timelines = result.timelines;
                    this.chaneTimelineContent();
                } else {
                    this.hasManage = false;
                }
            },
            deep: true
        },

        propertySelector: {
            handler(newVal, oldVal) {
                this.selectProp = newVal;
            },
            deep: true
        }
    },

    components: {
        manageDetails
    }
};
</script>

<style lang="scss">
.manageContainer {
    a {
        color: #333333;
    }
    @media (max-width: 414px) {
        .xs-link {
            display: inline-block;
            width: 100%;
        }
    }
    .property-selector {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-input__inner {
            width: 386px;
            height: 54px;
            border-radius: 6px;
            box-shadow: 0 6px 36px 0 rgba(0, 62, 100, 0.04);
            border: solid 1px #e5edf3;
            background-color: var(--white);
            @media (max-width: 768px) {
                width: 100%;
            }
        }
        .el-button {
            width: auto;
            height: 27px;
            line-height: 27px;
            border-radius: 2.6px;
            background-color: var(--windows-blue);
            border-color: transparent;
            padding-top: 0;
            padding-bottom: 0;
            font-family: GothamBook;
            font-size: 12px;
            letter-spacing: 0.3px;
            text-align: center;
            color: var(--white);
        }
    }
    .manage-table {
        padding: 20px;
        border-radius: 8px;
        box-shadow: 0 5px 10px -10px rgba(0, 0, 0, 0.2);
        border: solid 1px #eaf0f7;
        background-color: var(--white);
        margin-top: 20px;
        h2 {
            height: auto;
            line-height: normal;
            font-family: GothamMedium;
            font-size: 12px;
            letter-spacing: 1.12px;
            color: #333333;
            margin-bottom: 16px;
        }
        .table_header_style {
            th {
                border-bottom: none;
                background-color: #f6f9fc;
                .cell {
                    font-family: GothamMedium;
                    font-size: 11px;
                    color: var(--brownish-grey);
                    background-color: #f6f9fc;
                }
            }
        }
        .task {
            font-family: GothamBook;
            font-size: 13px;
            color: #333333;
            padding-left: 30px;
            position: relative;
            &::before {
                content: "";
                display: inline-block;
                width: 24px;
                height: 24px;
                background-size: contain;
                margin-right: 10px;
                margin-bottom: -6px;
                position: absolute;
                left: 0;
            }
            &.MORTGAGE::before {
                background: url("../../../../website_20/static/img/manage/icon-mortgage.svg")
                    no-repeat;
            }
            &.PAYMENT::before {
                background: url("../../../../website_20/static/img/manage/icon-payment.svg")
                    no-repeat;
            }
            &.DOCUMENT::before {
                background: url("../../../../website_20/static/img/manage/icon-document.svg")
                    no-repeat;
            }
            &.ADMIN::before {
                background: url("../../../../website_20/static/img/manage/icon-admin.svg")
                    no-repeat;
            }
            &.CLOSING::before {
                background: url("../../../../website_20/static/img/manage/icon-closing.svg")
                    no-repeat;
            }
            &.CONSTRUCTION::before {
                background: url("../../../../website_20/static/img/manage/icon-construction.svg")
                    no-repeat;
            }
        }
        .dueDate {
            font-family: GothamBook;
            font-size: 11px;
            color: var(--brownish-grey);
        }
        .status {
            font-family: GothamBook;
            font-size: 11px;
            color: var(--windows-blue);
            min-width: 70px;
            height: 23px;
            display: inline-block;
            position: relative;
            text-transform: capitalize;
            &::after {
                content: ">";
                display: inline-block;
                position: absolute;
                right: 0;
                color: var(--windows-blue);
                font-family: GothamMedium;
                margin-left: 6px;
            }
            &.completed {
                color: #5cb642;
                &::after {
                    content: "";
                    background: url("../../../../website_20/static/img/manage/icon-completed.svg")
                        no-repeat;
                    background-size: contain;
                    width: 14px;
                    height: 14px;
                    position: absolute;
                    right: -10px;
                    top: 4px;
                }
            }
            &.ERROR,
            &.OVERDUE {
                color: #bc3036;
                &::after {
                    color: #bc3036;
                }
            }
        }
        .table_noResult {
            position: relative;
            padding: 16px;
            padding-left: 86px;
            &::before {
                content: "";
                display: inline-block;
                width: 36px;
                height: 38px;
                position: absolute;
                left: 16px;
                top: 20%;
                background: url("../../../../website_20/static/img/manage/icon-required-actions.svg")
                    no-repeat;
                background-size: contain;
            }

            h4 {
                font-family: GothamBook;
                font-size: 13px;
                line-height: 1.2;
                color: #333333;
                margin-bottom: 3px;
            }
            p {
                height: 18px;
                line-height: 18px;
                font-family: GothamBook;
                font-size: 11px;
                line-height: 1.64;
                color: #8e8e8e;
            }
        }
    }

    .manage-content-r {
        .milestones {
            border-radius: 4px;
            box-shadow: 0 6px 36px 0 rgba(0, 62, 100, 0.03);
            border: solid 1px #e5edf3;
            background-color: #f2f7ff;
            .el-radio-group {
                margin-bottom: 25px;
                display: flex;
                justify-content: space-between;
                width: 100%;
                .el-radio-button {
                    width: 100%;
                    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.04);
                    display: inline-block;
                    .el-radio-button__inner {
                        width: 100%;
                        display: inline-block;
                        &:hover {
                            color: var(--windows-blue);
                        }
                    }
                }
            }
            .el-timeline {
                .el-timeline-item {
                    &.PENDING {
                        .el-timeline-item__node {
                            background: #fff;
                            border: 2px solid var(--windows-blue);
                        }
                    }
                    &.ERROR,
                    &.OVERDUE {
                        .el-timeline-item__node {
                            background: #fff;
                            border: 2px solid #bc3036;
                        }
                    }
                    &.COMPLETED,
                    &.UPDATE {
                        .el-timeline-item__node {
                            background-color: var(--windows-blue);
                        }
                    }
                }
            }
            .timeline_card {
                padding: 8px 14px;
                .card-link {
                    cursor: pointer;
                }
                .el-card__body {
                    padding: 0;
                }
            }
            .card-title {
                font-family: GothamMedium;
                font-size: 13px;
                line-height: 1.54;
                letter-spacing: 0.33px;
                color: #8e8e8e;
                position: relative;
                &.FUTURE_UPDATE {
                    color: #474747;
                }
                &.FUTURE {
                    color: #474747;
                }
                &.TODO,
                &.UPDATE {
                    color: var(--windows-blue);
                }
                &.PENDING {
                    color: var(--windows-blue);
                }
                &.OVERDUE,
                &.ERROR {
                    color: #bc3036;
                }

                &.document::after {
                    content: "";
                    display: inline-block;
                    position: absolute;
                    right: 0;
                    top: 4px;
                    width: 15px;
                    height: 15px;
                    background: url("../../../../website_20/static/img/manage/icon-attachment-grey.svg")
                        no-repeat;
                    background-size: contain;
                }
            }
            .card-date {
                font-family: GothamBook;
                font-size: 11px;
                letter-spacing: 0.34px;
                color: #9b9b9b;
                margin: 6px 0 0;
            }
            .card-btn {
                margin-top: 10px;
                padding-bottom: 0;
                padding-top: 0;
                font-family: GothamBook;
                font-size: 11px;
                color: var(--white);
                width: 100%;
                height: 26px;
                border-radius: 2px;
                border-color: transparent;
                background-color: var(--windows-blue);
                span::before {
                    content: "";
                    display: inline-block;
                    width: 12px;
                    height: 12px;
                    margin-bottom: -2px;
                    margin-right: 5px;
                    background-size: contain;
                }

                &.TODO span::before,
                &.OVERDUE span::before {
                    background: url("../../../../website_20/static/img/manage/icon-todo-white.svg")
                        no-repeat;
                }

                &.PENDING span::before {
                    background: url("../../../../website_20/static/img/manage/icon-pending-white.svg")
                        no-repeat;
                }
            }
            .no-result {
                padding-top: 62px;
                text-align: center;
                h3 {
                    font-family: GothamBook;
                    font-size: 13px;
                    line-height: 1.2;
                    text-align: center;
                    color: #333333;
                    margin-bottom: 8px;
                }
                p {
                    font-family: GothamBook;
                    font-size: 11px;
                    line-height: 1.2;
                    text-align: center;
                    color: var(--brownish-grey);
                    margin-bottom: 25px;
                }
                .solid-btn {
                    font-family: GothamBook;
                    font-size: 11px;
                    text-align: center;
                    color: var(--white);
                    line-height: normal;
                    padding: 8px 0;
                    height: 32px;
                    border-color: transparent;
                    box-shadow: none;
                    border-radius: 4px;
                    background-color: var(--windows-blue);
                }
            }
        }
    }

    .manage-content-empty {
        border-top: solid 1px #e4edf4;
        margin-top: 28px;
        padding-top: 37px;
        h1 {
            font-family: GothamBook;
            font-size: 22px;
            text-align: center;
            color: #0c253d;
            margin-bottom: 16px;
        }

        .manage-desc {
            font-family: GothamBook;
            font-size: 14px;
            line-height: 0.93;
            text-align: center;
            color: var(--brownish-grey);
            margin-bottom: 16px;
        }
        .solid-btn {
            box-shadow: none;
            height: 27px;
            line-height: 27px;
            border-radius: 2.6px;
            background-color: var(--windows-blue);
            border: 0;
            padding-top: 0;
            padding-bottom: 0;
            display: block;
            margin: 0 auto;
            font-family: GothamBook;
            font-size: 12px;
            letter-spacing: 0.3px;
            text-align: center;
            color: var(--white);
        }

        .empty-list {
            margin-top: 25px;
            display: flex;
            justify-content: space-between;
            margin-bottom: 100px;

            li {
                width: 100%;
                height: 360px;
                border-radius: 4px;
                box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.14);
                background-color: #f0f3ff;
                padding: 24px 18px;
                text-align: center;
                &:nth-child(2) {
                    margin: 0 25px;
                }

                .icon-empty {
                    width: 69px;
                    height: 69px;
                    margin: 0 auto;
                    display: block;
                    margin-bottom: 20px;
                    background-repeat: no-repeat;
                    background-size: contain;
                    &.icon-income {
                        background-image: url("../../../../website_20/static/img/manage/icon-income.svg");
                    }
                    &.icon-returns {
                        background-image: url("../../../../website_20/static/img/manage/icon-returns.svg");
                    }
                    &.icon-cost {
                        background-image: url("../../../../website_20/static/img/manage/icon-cost.svg");
                    }
                }

                p {
                    font-family: GothamMedium;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 1.54;
                    text-align: center;
                    color: #333333;
                    margin-bottom: 20px;
                }

                .empty-img {
                    width: 100%;
                    height: 152px;
                    margin: 0 auto;
                    display: block;
                    margin-bottom: 20px;
                    background-repeat: no-repeat;
                    background-size: cover;
                    &.empty-income {
                        background-image: url("../../../../website_20/static/img/manage/empty-income.svg");
                    }
                    &.empty-returns {
                        background-image: url("../../../../website_20/static/img/manage/empty-returns.svg");
                    }
                    &.empty-cost {
                        background-image: url("../../../../website_20/static/img/manage/empty-cost.svg");
                    }
                }

                a {
                    font-family: GothamBook;
                    font-size: 12px;
                    color: #2c2e30;
                    text-decoration: underline;
                    &::after {
                        content: "";
                        display: inline-block;
                        width: 11px;
                        height: 7px;
                        background: url("../../../../website_20/static/img/manage/tail-right.svg")
                            no-repeat;
                        background-size: contain;
                        margin-left: 10px;
                    }
                }
            }
        }
    }

    @media (max-width: 992px) {
        .property-selector {
            .el-select {
                width: 100%;
            }
        }
    }

    @media (max-width: 768px) {
        .manage-content-empty {
            .manage-desc {
                line-height: 1.75;
            }
            .empty-list {
                flex-wrap: wrap;
                li {
                    width: 50%;
                    margin-bottom: 26px;
                    &:nth-child(2) {
                        margin: 0;
                        width: calc(50% - 10px);
                        margin-left: 10px;
                    }
                    &:first-child,
                    &:last-child {
                        width: calc(50% - 10px);
                        margin-right: 10px;
                    }
                }
            }
        }
    }

    @media (max-width: 414px) {
        .manage-content-empty {
            .empty-list {
                margin-bottom: 0;
                li {
                    &:first-child,
                    &:last-child,
                    &:nth-child(2) {
                        width: 100%;
                        margin: 0 0 26px;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/account/manageContainer.vue